// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_rehype-highlight_index_js":"d86a7f88c39333208c45","node_modules_nextcloud_dialogs_dist_chunks_index-Cp_Wd5Qd_mjs":"ecbaccced8a0b9e8eba9","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-Bp973DaS_mjs":"9490cf02d554283964da"}[chunkId] + "";
};